module.exports = __webpack_public_path__ + "media/images/logo_square-5f40decf0c326198574b4301d3579c32.png";